// extracted by mini-css-extract-plugin
module.exports = {"page_title":"BlogPage_page_title__sSpAa","page_subtitle":"BlogPage_page_subtitle__2VJ91"};